<div *ngIf="isActive" class="suggest-language-change">
  <p class="phrase-text">{{ suggestedContent }}</p>

  <div class="actions-wrap">
    <div class="select-wrap">
      <on-ui-select [(ngModel)]="selectedLanguageId" [options]="languagesOptions"></on-ui-select>
    </div>
    <div class="button-wrap">
      <on-ui-button (click)="acceptSuggestedLanguage()"
                    class="primary outline"
                    [label]="buttonTitle">
      </on-ui-button>
    </div>
  </div>

  <div class="close-action" (click)="disableLanguageSuggest()">
    <app-icon width="20" height="20" icon="close-sidebar"></app-icon>
  </div>
</div>
